let sticky = null;

const hideFlashMessage = () => {
  const flashContainer = document.querySelector('#flash-container');
  const flashContent = document.querySelector('#flash-content');

  flashContent.innerHTML = '';
  flashContainer.classList.remove('is-active');
  sticky = null;
};

function stick() {
  const header = document.querySelector('header');
  const flashContainer = document.querySelector('#flash-container');
  if (sticky) {
    if (window.pageYOffset < header.getBoundingClientRect().height) {
      flashContainer.classList.remove('sticky');
      flashContainer.style.top = `${header.getBoundingClientRect().bottom}px`;
    } else if (window.pageYOffset > sticky) {
      flashContainer.classList.add('sticky');
    }
  }
}

window.showFlashMessage = (message, timeout) => {
  const header = document.querySelector('header');
  const flashContainer = document.querySelector('#flash-container');
  const flashContent = document.querySelector('#flash-content');
  const closeFlashContainer = document.querySelector('#close-flash-container');

  flashContainer.classList.add('is-active');
  flashContent.innerHTML = message;

  closeFlashContainer.addEventListener('click', hideFlashMessage, false);

  sticky = header.getBoundingClientRect().height;
  stick();
  setTimeout(hideFlashMessage, timeout);
};

window.hideFlashMessage = hideFlashMessage;
window.onscroll = stick;
